import { Stack } from "@mantine/core";
import { ReferralSettings } from "@/pages/Settings/components/ReferralSettings";
import SettingsHeader from "@/pages/Settings/SettingsHeader/SettingsHeader";
import OnboardingPageContainer from "./OnboardingPageContainer";

interface ReferralOnboardingProps {
  onExit?: () => void;
}

/**
 * Referral settings view for onboarding flow
 * Wraps the ReferralSettings component with appropriate header
 */
const ReferralOnboarding = ({ onExit }: ReferralOnboardingProps) => {
  return (
    <OnboardingPageContainer onExit={onExit}>
      <Stack gap="md">
        <SettingsHeader
          title="Referral Program"
          description="Share your referral link and earn rewards"
        />
        <ReferralSettings />
      </Stack>
    </OnboardingPageContainer>
  );
};

export default ReferralOnboarding;
